import React from 'react';

const Error404Image = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="400"
    height="148"
    viewBox="0 0 400 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.4452 145.218C91.2534 145.218 115.418 143.822 115.418 142.1C115.418 140.378 91.2534 138.982 61.4452 138.982C31.637 138.982 7.47266 140.378 7.47266 142.1C7.47266 143.822 31.637 145.218 61.4452 145.218Z"
      fill="#D8D8D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M173.142 3.51953C177.313 4.33722 181.653 7.22991 185.164 11.6106L183.685 21.7834L187.648 15.2026C188.108 15.9766 188.543 16.7817 188.95 17.6155C192.709 25.3229 193.027 33.4288 190.325 38.7512C186.804 38.0607 183.162 35.8915 180 32.5966L186.412 30.8466L177.155 29.1312C176.187 27.7557 175.299 26.2587 174.517 24.6549C172.931 21.4025 171.957 18.0791 171.565 14.9238L178.858 15.8122L171.366 11.5336C171.395 8.61001 171.964 5.9294 173.045 3.71309L173.142 3.51953Z"
      fill="#247D70"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.653 35.0447C165.504 33.2694 168.175 32.2061 171.11 32.1104L174.597 37.1609L173.513 32.2465C174.056 32.3253 174.602 32.4373 175.149 32.5838C179.573 33.7691 182.839 36.8997 183.875 40.4632C181.196 43.0317 176.802 44.1096 172.378 42.9243C170.506 42.4226 168.841 41.5726 167.465 40.4888L170.44 37.2344L166.136 39.2762C164.986 38.0604 164.146 36.6562 163.691 35.1734L163.653 35.0447Z"
      fill="#56CBB9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.743 17.3494C220.312 20.1658 220.744 23.7416 219.903 27.3079L212.774 29.7982L218.971 30.1087C218.712 30.707 218.414 31.2992 218.078 31.8814C215.253 36.7758 210.448 39.6521 205.826 39.7231C203.575 35.6848 203.664 30.0852 206.489 25.1906C207.684 23.1214 209.232 21.4129 210.971 20.1246L213.999 24.8103L212.881 18.9177C214.703 17.9507 216.653 17.4101 218.576 17.3526L218.743 17.3494Z"
      fill="#247D70"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M233.098 34.9644C231.018 33.464 228.224 32.7829 225.305 33.0964L222.555 38.5831L222.944 33.5658C222.418 33.7194 221.892 33.9063 221.371 34.1274C217.155 35.9169 214.356 39.4717 213.827 43.1446C216.837 45.3153 221.338 45.7712 225.554 43.9817C227.338 43.2244 228.869 42.1509 230.081 40.8861L226.682 38.0774L231.228 39.5002C232.197 38.1364 232.834 36.6288 233.078 35.0972L233.098 34.9644Z"
      fill="#56CBB9"
    />
    <path d="M179.203 38.7578L187.232 40.985L190.801 46.7757" stroke="#0D5147" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M205.401 7.82298C207.928 10.6595 209.404 14.8704 209.465 19.5661L202.47 25.219L209.228 23.2405C209.106 24.1089 208.937 24.9854 208.717 25.8651C206.949 32.9562 202.424 38.3495 197.319 40.2384C193.698 36.1737 192.234 29.2873 194.002 22.1962C194.774 19.0994 196.072 16.3265 197.715 14.0278L202.436 18.6381L199.534 11.8199C201.238 10.0301 203.179 8.68239 205.217 7.89265L205.401 7.82298Z"
      fill="#56CBB9"
    />
    <path d="M219.794 41.876L211.765 43.6578L209.535 46.7759" stroke="#0D5147" strokeWidth="0.5" />
    <path d="M188.125 34.3034L191.693 40.0941L192.585 46.3303" stroke="#0D5147" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.5036 75.7294H82.9787L62.9063 142.517H59.7839L74.5036 75.7294Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.8708 75.7293L63.7983 142.517H62.0141L82.0866 75.7293H83.8708Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.1295 76.2028H88.6545L108.727 142.991H111.849L97.1295 76.2028Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.1295 76.2028L111.849 142.991H110.065L95.3453 76.2028H97.1295Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.5531 74.5058L111.724 70.6989L112.035 75.4329L60.8642 79.2397L60.5531 74.5058Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.275 71.0299L111.724 70.6988L112.035 75.4328L107.586 75.7638L107.275 71.0299Z"
      fill="#824D18"
    />
    <path d="M198.83 35.1943L197.492 40.0942V46.3304" stroke="#0D5147" strokeWidth="0.5" />
    <path d="M208.197 36.0853L205.967 39.6488L204.628 47.2212" stroke="#0D5147" strokeWidth="0.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.447 46.3304H212.212C213.936 46.3304 215.334 47.7278 215.334 49.4516V68.1453C215.334 74.548 210.143 79.7384 203.741 79.7384H193.919C187.516 79.7384 182.326 74.548 182.326 68.1453V49.4516C182.326 47.7278 183.723 46.3304 185.447 46.3304Z"
      fill="#FFFBFB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M212.213 46.3304C213.936 46.3304 215.334 47.7278 215.334 49.4516V68.1453C215.334 74.548 210.143 79.7384 203.741 79.7384H200.172C206.575 79.7384 211.765 74.548 211.765 68.1453V49.4516C211.765 47.7278 210.368 46.3304 208.644 46.3304H212.213Z"
      fill="#F2F2F2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.421 81.52H173.851L154.357 142.847C154.076 143.728 153.258 144.327 152.333 144.327C151.653 144.327 151.101 143.775 151.101 143.095C151.101 143 151.112 142.906 151.133 142.815L165.421 81.52Z"
      fill="#8D5219"
    />
    <path
      d="M192.585 147.445C222.393 147.445 246.558 145.551 246.558 143.213C246.558 140.876 222.393 138.982 192.585 138.982C162.777 138.982 138.612 140.876 138.612 143.213C138.612 145.551 162.777 147.445 192.585 147.445Z"
      fill="#D8D8D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.78456 13.0209L51.4444 12.9248C54.0422 12.9193 56.3263 14.6429 57.0339 17.1424L77.206 88.3986C78.078 91.4789 76.2878 94.6829 73.2076 95.5549C72.6939 95.7003 72.1625 95.7741 71.6287 95.7741H10.4947C7.44163 95.7741 4.91192 93.4059 4.71079 90.3594L0.0128079 19.1993C-0.198086 16.0049 2.22052 13.2444 5.4149 13.0335C5.53796 13.0254 5.66124 13.0212 5.78456 13.0209Z"
      fill="#FEB63B"
    />
    <path
      d="M98.9145 89.0925H7.02583C5.79454 89.0925 4.79639 90.0906 4.79639 91.3219V102.008C4.79639 103.239 5.79454 104.237 7.02583 104.237H98.9145C100.146 104.237 101.144 103.239 101.144 102.008V91.3219C101.144 90.0906 100.146 89.0925 98.9145 89.0925Z"
      fill="#FFC055"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3152 77.066H30.7903L10.7178 143.854H7.59546L22.3152 77.066Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.6824 77.066L11.61 143.854H9.82574L29.8982 77.066H31.6824Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9411 77.5396H36.4661L56.5385 144.327H59.6609L44.9411 77.5396Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9411 77.5396L59.6609 144.327H57.8767L43.1569 77.5396H44.9411Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.36473 75.8422L59.536 72.0353L59.8471 76.7693L8.67588 80.5762L8.36473 75.8422Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.0864 72.3664L59.536 72.0354L59.8472 76.7693L55.3975 77.1004L55.0864 72.3664Z"
      fill="#824D18"
    />
    <path
      d="M346.028 145.218C316.219 145.218 292.055 143.822 292.055 142.1C292.055 140.378 316.219 138.982 346.028 138.982C375.836 138.982 400 140.378 400 142.1C400 143.822 375.836 145.218 346.028 145.218Z"
      fill="#D8D8D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M320.926 75.7292H312.451L332.523 142.517H335.645L320.926 75.7292Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M311.559 75.7292L331.631 142.517H333.415L313.343 75.7292H311.559Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M298.3 76.2028H306.775L286.702 142.991H283.58L298.3 76.2028Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M298.3 76.2028L283.58 142.991H285.364L300.084 76.2028H298.3Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M334.876 74.5058L283.705 70.6989L283.394 75.4329L334.565 79.2398L334.876 74.5058Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M288.155 71.0299L283.705 70.6988L283.394 75.4328L287.844 75.7638L288.155 71.0299Z"
      fill="#824D18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M379.832 13.0209L334.172 12.9248C331.574 12.9193 329.29 14.6429 328.582 17.1424L308.41 88.3986C307.538 91.4789 309.328 94.6829 312.408 95.5549C312.922 95.7003 313.453 95.7741 313.987 95.7741H375.121C378.174 95.7741 380.704 93.4059 380.905 90.3594L385.603 19.1993C385.814 16.0049 383.396 13.2444 380.201 13.0335C380.078 13.0254 379.955 13.0212 379.832 13.0209Z"
      fill="#FEB63B"
    />
    <path
      d="M286.702 89.0925H378.59C379.822 89.0925 380.82 90.0906 380.82 91.3219V102.008C380.82 103.239 379.822 104.237 378.59 104.237H286.702C285.47 104.237 284.472 103.239 284.472 102.008V91.3219C284.472 90.0906 285.47 89.0925 286.702 89.0925Z"
      fill="#FFC055"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M371.33 77.066H362.855L382.927 143.854H386.049L371.33 77.066Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M361.963 77.066L382.035 143.854H383.819L363.747 77.066H361.963Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M348.704 77.5396H357.179L337.107 144.327H333.984L348.704 77.5396Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M348.704 77.5396L333.984 144.327H335.768L350.488 77.5396H348.704Z"
      fill="#7C4612"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M385.28 75.8422L334.109 72.0353L333.798 76.7693L384.969 80.5762L385.28 75.8422Z"
      fill="#AB6C2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M338.559 72.3664L334.109 72.0354L333.798 76.7693L338.248 77.1004L338.559 72.3664Z"
      fill="#824D18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.578 128.291L158.685 129.531L154.385 142.84C154.099 143.726 153.273 144.327 152.341 144.327C151.659 144.327 151.105 143.774 151.105 143.091C151.105 142.995 151.117 142.9 151.139 142.806L154.578 128.291Z"
      fill="#D1A65C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193.031 81.52H201.506L198.778 141.431C198.738 142.304 198.019 142.991 197.146 142.991C196.273 142.991 195.556 142.303 195.52 141.431L193.031 81.52Z"
      fill="#8D5219"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M199.275 130.519L198.795 141.506C198.759 142.337 198.075 142.991 197.245 142.991C196.414 142.991 195.733 142.336 195.699 141.506L195.261 130.519H199.275Z"
      fill="#D1A65C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M229.562 81.52H221.133L240.627 142.847C240.907 143.728 241.725 144.327 242.65 144.327C243.33 144.327 243.882 143.775 243.882 143.095C243.882 143 243.871 142.906 243.85 142.815L229.562 81.52Z"
      fill="#8D5219"
    />
    <path
      d="M249.457 79.7383H143.296C142.68 79.7383 142.181 80.2374 142.181 80.853V81.7416C142.181 82.3573 142.68 82.8564 143.296 82.8564H249.457C250.073 82.8564 250.572 82.3573 250.572 81.7416V80.853C250.572 80.2374 250.073 79.7383 249.457 79.7383Z"
      fill="#A4DDD5"
    />
    <path
      d="M236.968 82.8564H157.569C156.954 82.8564 156.455 83.3555 156.455 83.9711V84.4143C156.455 85.03 156.954 85.529 157.569 85.529H236.968C237.583 85.529 238.082 85.03 238.082 84.4143V83.9711C238.082 83.3555 237.583 82.8564 236.968 82.8564Z"
      fill="#75471A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M240.439 128.737L243.847 143.24C243.869 143.333 243.88 143.429 243.88 143.525C243.88 144.214 243.321 144.772 242.632 144.772C241.694 144.772 240.863 144.166 240.577 143.273L236.298 129.919L240.439 128.737Z"
      fill="#D1A65C"
    />
  </svg>
);

export default Error404Image;
